import { useEffect, useState } from "react";
import authApi from "../../api/authApi";

interface ConnectGooglePopupProps {
    onClose: () => void;   // parent sẽ unmount popup
    onCancel: () => void;
    onSuccess: () => void;
}

export default function ConnectGooglePopup(props: ConnectGooglePopupProps) {
    const { onClose, onCancel, onSuccess } = props;
    const [visible, setVisible] = useState(false); // chỉ dùng cho animation

    useEffect(() => {
        setTimeout(() => setVisible(true), 10);
    }, []);

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            setVisible(false);
            setTimeout(onClose, 300); // chờ animation rồi tắt
        }
    };

    const handleAgree = async () => {
        const newTab: Window | null = window.open("", "_blank");

        try {
            const res = await authApi.connectWithGoogle();

            if (newTab) {
                newTab.location.href = res.data;
            }

            // Tắt popup sau khi redirect tab mới
            setVisible(false);
            setTimeout(onSuccess, 300);

        } catch (err) {
            if (newTab) newTab.close();
            setVisible(false);
            setTimeout(onClose, 300);
        }
    };

    return (
        <div
            className="fixed inset-0 bg-[rgba(0,0,0,0.5)] z-50 flex justify-center items-center transition-opacity duration-300"
            style={{ opacity: visible ? 1 : 0 }}
            onClick={handleOverlayClick}
        >
            <div
                className={`relative w-[90%] lg:w-[400px] bg-white p-[20px] rounded-box shadow-lg transform transition-all duration-300
                    ${visible ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"}`}
            >
                <h2 className="text-secondary font-bold text-[20px] mt-[20px] text-center">
                    Để tạo link học, bạn cần kết nối với Google Meet. Bạn có muốn tiếp tục?
                </h2>

                <div className="flex justify-center mt-[40px]">
                    <button
                        onClick={handleAgree}
                        className="bg-red-500 text-white px-[15px] py-[8px] rounded-[5px] min-w-[100px] hover:bg-red-600"
                    >
                        Đồng ý
                    </button>
                    <button
                        onClick={onCancel}
                        className="ml-[20px] bg-secondary opacity-90 hover:opacity-100 text-white px-[15px] py-[8px] rounded-[5px] min-w-[100px]"
                    >
                        Hủy
                    </button>
                </div>
            </div>
        </div>
    );
}
